
export class updateTemplateOBj {
    static readonly type = '[updateTemplateOBj] updateTemplateOBj';

    constructor(public payload: any) {
    }
}   